import React, { useCallback, useEffect, useRef } from 'react';
import 'video.js/dist/video-js.css';
import 'videojs-resolution-switcher/lib/videojs-resolution-switcher.css';

const useVideoJS = videoJsOptions => {
  const videoNodeRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    const videojs = require('video.js');
    require('videojs-resolution-switcher');
    playerRef.current = videojs(videoNodeRef.current, videoJsOptions, function onInit() {
      if (!videoJsOptions.startTime) {
        return;
      }

      // On Safari when you seek to new position videojs player breaks.
      // But if you seek after video starts playing, then it's ok
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        const seekToStartPosition = () => {
          this.currentTime(videoJsOptions.startTime);
          this.off('canplay', seekToStartPosition);
        };
        this.on('canplay', seekToStartPosition);
      } else {
        this.currentTime(videoJsOptions.startTime);
      }
    });

    return () => {
      playerRef.current.dispose();
    };
  }, [videoJsOptions]);

  const Video = useCallback(
    ({ children, ...props }) => {
      return (
        <div data-vjs-player>
          <video ref={videoNodeRef} className="video-js vjs-big-play-centered" {...props}>
            {children}
          </video>
        </div>
      );
    },
    [videoJsOptions],
  );
  return { Video, playerRef: playerRef, videoNodeRef: videoNodeRef };
};
export default useVideoJS;
